import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oraclePeopleSoft = defineConnector({
  identifier: "oraclePeopleSoft",
  name: "Oracle PeopleSoft",
  tagLine: "Enterprise application suite",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://.*\\.peoplesoft\\.oracle\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your PeopleSoft API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. Sign in to your PeopleSoft application
2. Navigate to **PeopleTools › Integration Broker › Integration Setup**
3. Ensure the REST services are enabled
4. Obtain your username and password with the required roles`,
        },
      ],
    },
    {
      title: "Enter your PeopleSoft details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://ps.yourcompany.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "Your PeopleSoft server URL.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) =>
      `${serverUrl}/PSIGW/RESTListeningConnector/PSFT_HR/`,
  },
  publicEnvVars: ({ serverUrl }) => ({
    ORACLE_PEOPLE_SOFT_URL: serverUrl || "",
  }),
});
